import axios from "../api";
export const markSbcSetAsFavorite = async (setId, isFavorite) => {
    await axios.post("/favorite-sbc-set", { setId, isFavorite });
};
//# sourceMappingURL=markSbcSetAsFavorite.js.map